// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"
import "./channels"

Turbo.StreamActions.move_to_top = function () {
  const row = this.targetElements[0]
  const replacement = this.templateContent.firstElementChild
  const list = document.getElementById("whatsapp_conversations_list")

  if (!replacement || !list) return
  if (!row && list.dataset.whatsappInboxFilterValue !== "") return

  const event = new CustomEvent("whatsapp:inbox-row-update", {
    bubbles: true,
    cancelable: true,
    detail: { list }
  })
  document.dispatchEvent(event)
  if (event.defaultPrevented) return

  document.getElementById("whatsapp_conversations_empty")?.remove()
  row?.replaceWith(replacement)
  list.prepend(replacement)
}
